import React, { useEffect, useMemo } from "react";
import { DlUnit } from "model/dl_unit/DlUnit";
import { useUnitUrlSearch } from "hooks/citajteo/dl_unit/useUnitSearch";
import UnitList from "./UnitList";
import SearchTextActivate from "components/navigation/search/SearchTextActivate/SearchTextActivate";
import styled from "styled-components";
import SearchNavigation from "components/navigation/search/SearchNavigation/SearchNavigation";
import { useUnitSearchOptionsFromUrl } from "hooks/citajteo/dl_unit/useUnitSearchOptionsFromUrl";
import { DL_UNIT_PER_PAGE_MAX } from "constant/dl_unit/dl_unit.constant";
import { SEARCH_NAMES } from "constant/search/search";
import { useSearchParams } from "react-router-dom";

type UnitSearchListProps = {
  navigateToSearch?: boolean;
};

const UnitSearchList = ({ navigateToSearch }: UnitSearchListProps) => {
  const unitListResult = useUnitUrlSearch();
  const unitSearchParams = useUnitSearchOptionsFromUrl();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    console.log(
      "unitSearchParams[SEARCH_NAMES.SEARCH_TEXT]",
      unitSearchParams[SEARCH_NAMES.SEARCH_TEXT],
    );
  }, [unitSearchParams]);

  const defaultSearchText = useMemo<string>(() => {
    return unitSearchParams[SEARCH_NAMES.SEARCH_TEXT]
      ? unitSearchParams[SEARCH_NAMES.SEARCH_TEXT] + ""
      : "";
  }, [unitSearchParams, unitSearchParams[SEARCH_NAMES.SEARCH_TEXT]]);

  const results: DlUnit[] = unitListResult ? unitListResult["items"] : [];

  const limit = +(unitSearchParams[SEARCH_NAMES.LIMIT] ?? DL_UNIT_PER_PAGE_MAX);
  const skip = +(unitSearchParams[SEARCH_NAMES.SKIP] ?? 0);
  const searchNavLiAct = (newSkip: number) => {
    // console.log("searchNavLiAct", newSkip);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(SEARCH_NAMES.SKIP, newSkip + "");
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <Div>
        <SearchTextActivate
          searchLabel=""
          placeholder="Pretraživanje"
          navigateToSearch={navigateToSearch}
          defaultSearchText={defaultSearchText}
        />
        <SearchNavigation
          totalCount={unitListResult?.resTotal ?? 0}
          skip={skip}
          limit={limit}
          navAct={searchNavLiAct}
        />
      </Div>
      {results && results.length > 0 && (
        <Div>
          {/* <TopicSearchFilters searchHandle={searchHandle} /> */}
          <UnitList units={results} />
        </Div>
      )}
    </>
  );
};

const Div = styled.div`
  margin-top: ${(props) => props.theme.spacing.l};
`;

export default UnitSearchList;
